import { Button } from '../../components/Button/Button';
import { useIcons } from '../../hooks/useIcons';

interface TtsInfoButtonProps {
  onClick: () => void;
}

export const TtsInfoButton = ({ onClick }: TtsInfoButtonProps) => {
  const { Info } = useIcons();

  return (
    <Button
      onClick={onClick}
      className="vgp-tts-layout-info-button"
      color="text"
      size="xsmall"
    >
      <Info />
    </Button>
  );
};
